import React from 'react'
import createReactClass from 'create-react-class'
import ModalWrapper from './modal-wrapper'
import ModalContent from './modal-content'
import {copyToClipboard} from '../../util/helpers'
import MdContentCopy from 'react-icons/lib/md/content-copy'
import './view-url-modal-panel.scss'

export default createReactClass({
  getInitialState () {
    return {
      infoMessage: '',
      copyError: false,
    }
  },
  onCopyURLToClipboard () {
    let success = copyToClipboard(this.props.url, document)
    if (success) {
      this.setState({infoMessage: 'URL copied to clipboard', copyError: false})
    } else {
      this.setState({infoMessage: 'URL not copied to clipboard', copyError: true})
    }
  },
  renderInfoMessage () {
    return this.state.infoMessage ? (
      <div className={this.state.copyError ? 'copy-message error' : 'copy-message'}>{this.state.infoMessage}</div>
    ) : false
  },
  render () {
    return (
      <ModalWrapper>
        <ModalContent title='View Request URL' {...this.props}>
          <div className='row'>{this.renderInfoMessage()}</div>
          {this.props.type
            ? <div className='row'>
              <label>Request Type:</label>
              <div className='req-type-value'>{this.props.type}</div>
            </div>
            : null}
          {this.props.url
            ? <div className='row'>
              <label>Request Url:</label>
              <div className='req-url-block'>
                <textarea className='' defaultValue={this.props.url} cols="42" readOnly/>
                <div className='copy-url-icon' title="Copy url" onClick={this.onCopyURLToClipboard}><MdContentCopy /></div>
              </div>
            </div>
            : <div className="text-center">Request url has not build yet!</div>}
        </ModalContent>
      </ModalWrapper>
    )
  },
})



// WEBPACK FOOTER //
// ./src/components/modal-panels/view-url-modal-panel.js